// extracted by mini-css-extract-plugin
export var displayNone = "_r4-6";
export var imgContainer = "_r4-2";
export var overflowHidden = "_r4-3";
export var productInfoCardButtonContainer = "_r4-5";
export var productTitleText = "_r4-4";
export var rightArrow = "_r4-1";
export var rightArrowContainer = "_r4-0";